import { tagsFilterAtom } from 'atoms/filters/sim-products';
import { tagsHintsAtom } from 'atoms/hints/sim-products';
import { TagsSearchFilter } from 'tags/Components/TagsSearchFilter';

export const TagsSearchInput = () => {
  return <TagsSearchFilter tagsFilterAtom={tagsFilterAtom} tagsHintsAtom={tagsHintsAtom} />;
};
